import { useQuery } from "@tanstack/react-query";

import { getAgentIntentGraph } from "@/pages/agent/intent-graph/agent-intent-graph-api";

export const useAgentIntentGraph = ({ enabled = true }: { enabled?: boolean } = {}) =>
  useQuery({
    queryKey: ["agent-intent-graph"],
    queryFn: getAgentIntentGraph,
    enabled,
    staleTime: 30_000,
  });
